import React, { Component } from 'react';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Colors from '../../../../styles/colors';
import Loading from '../../../../components/Loading';
import CustomDialog from '../custom_dialog';
import IntegrationWizard from '../integrations';
import { publisherManager } from '../../../../helpers/managers';

class EmailListModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      integration: {},
    };
  }

  componentDidMount() {
    this.updateMailChimpList();
  }

  async updateMailChimpList() {
    const { userInfo } = this.props;
    if (isEmpty(userInfo) || !('publisher' in userInfo)) return;

    const { id: publisherId = '' } = userInfo.publisher || {};
    const apiKey = await publisherManager.getProp(publisherId, 'mailChimp/apiKey');
    if (!isEmpty(apiKey)) {
      // update list
      Axios.post('/api/integration/mailchimp', {
        publisherId,
        apiKey,
      }).catch(error => {
        console.log(error);
      });
    }
  }

  closeModal = () => {
    this.props.onClose();
  };

  handleIntegrationUpdate = integration => {
    console.log('integration update', integration);
    this.setState({
      integration,
    });
  };

  handleIntegrationSave = () => {
    this.alertDialog.showModal({
      content: 'Subscribers exported to your email list.',
    });
  };

  render() {
    const { integration = {} } = this.state;
    const { isShown, soundcasts, userInfo, currentSoundcastID } = this.props;
    if (!isShown) {
      return null;
    }

    const { completed = false, saving = false, error } = integration;

    return (
      <MuiThemeProvider>
        <React.Fragment>
          <Dialog
            title="Automatic Export to Email List"
            actions={[
              <DialogActions>
                <FlatButton label="Close" onClick={this.closeModal} disabled={saving} />
                <div className="actions">
                  {!saving && (
                    <FlatButton
                      label="Save"
                      labelStyle={{
                        color: !completed ? '#ffb388' : Colors.mainOrange,
                      }}
                      onClick={() => this.integrationWizard.save()}
                      disabled={!completed}
                    />
                  )}
                  {saving && (
                    <Loading
                      text="SAVING..."
                      type="circle"
                      align="left"
                      size={20}
                      fontSize={1.4}
                      color={Colors.mainOrange}
                      fill={Colors.mainOrange}
                    />
                  )}
                </div>
              </DialogActions>,
            ]}
            modal={false}
            open={isShown}
            contentStyle={{
              width: '95%',
              maxWidth: 720,
              height: 700,
              maxHeight: 'none',
            }}
            autoScrollBodyContent={true}>
            {!isEmpty(error) && (
              <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                  <div className="alert alert-danger text-medium" role="alert">
                    {error}
                  </div>
                </div>
              </div>
            )}
            <IntegrationWizard
              ref={ref => (this.integrationWizard = ref)}
              soundcastId={currentSoundcastID}
              soundcasts={soundcasts}
              userInfo={userInfo}
              onUpdate={this.handleIntegrationUpdate}
              onSave={this.handleIntegrationSave}
            />
          </Dialog>
          <CustomDialog ref={ref => (this.alertDialog = ref)} />
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

const DialogActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  .actions {
    display: flex;
    flex-direction: row;
  }
`;

export default EmailListModal;
